import React, { Component, Fragment } from "react";
import {Modal, ModalBody, Button, ModalHeader } from "reactstrap";
import ProyectoCursoForm from "./ProyectoCursoForm"

class ProyectoCursoModal extends Component {
    state = {
        modal: false
      };

    toggle = () => {
    this.setState(previous => ({
        modal: !previous.modal
    }));
    };  

    render() {
        const create = this.props.create;
        const proyectoCode = this.props.proyectoCodeSelected;
        const proyectoName = this.props.proyectoNameSelected;

        var title = "Editando grupos/estudiantes del Curso Cerrado";
        var button = <Button onClick={this.toggle}>
        Editar
        </Button>;

        if (create) {
            title = "Agregando grupos/estudiantes al Curso Cerrado";

            button = (
            <Button
                color="primary"
                className="float-end"
                onClick={this.toggle}
                style={{ minWidth: "200px" }}
            >
                Agregar Estudiantes al Curso
            </Button>
            );
        }

    return (
      <Fragment>
        {button}
        <Modal isOpen={this.state.modal} toggle={this.toggle} unmountOnClose>
        <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
          <ModalBody>
            <ProyectoCursoForm
              resetState={this.props.resetState}
              toggle={this.toggle}
              proyectoCode= {proyectoCode}
              proyectoName = {proyectoName}
              partida_curso={this.props.partida_curso}
              proyectoMoneda={this.props.proyectoMoneda}
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default ProyectoCursoModal;